module.exports = __webpack_public_path__ + "img/user.0a292da2.png";